<script lang="ts">
	import type { BlogCategory } from '$models/Blog/BlogCategory';
	import { goto } from '$app/navigation';

	let { categories, selectLabel }: { categories: BlogCategory[]; selectLabel: string } = $props();

	function onCategoryChange(event: Event) {
		const value = (event.target as HTMLSelectElement).value;
		if (value) {
			goto(value);
		}
	}
</script>

<div class="blog-category-switcher">
	<ul class="blog-category-switcher-list">
		{#each categories as category}
			<li class="blog-category-switcher-item">
				<a
					href={category.path}
					class="blog-category-switcher-link"
					class:is-active={category.isActive}
					aria-current={category.isActive ? 'page' : undefined}
				>
					{category.name}
				</a>
			</li>
		{/each}
	</ul>

	<div class="blog-category-switcher-select">
		<label for="blog-category-select" class="screenreader">{selectLabel}</label>
		<select id="blog-category-select" onchange={onCategoryChange}>
			{#each categories as category}
				<option value={category.path} selected={category.isActive}>{category.name}</option>
			{/each}
		</select>
	</div>
</div>

<style lang="postcss">
	.blog-category-switcher {
		margin-bottom: 40px;

		&-list {
			display: none;
		}

		&-link {
			display: flex;
			align-items: center;
			justify-content: center;
			color: var(--color-brown);
			font-size: var(--font-size-1);
			padding: 8px 16px;
			border: 1px solid var(--color-brown);
			border-radius: 40px;
			white-space: nowrap;
			transition:
				color var(--transition),
				border-color var(--transition),
				background-color var(--transition);

			&:hover {
				background-color: var(--variant-tint-2-color);
			}

			&:focus-visible {
				outline: 2px solid var(--color-brown);
				outline-offset: 2px;
			}

			&.is-active {
				color: var(--color-white);
				background: var(--color-brown);
				border-color: var(--color-brown);
			}
		}

		&-select {
			select {
				padding: 20px 16px;
				font-family: var(--font-secondary);
				font-size: 13px;
				text-transform: uppercase;
				line-height: 1;
				border-radius: 8px;
			}

			option {
				text-transform: none;
			}
		}

		@media (--md) {
			&-list {
				display: flex;
				justify-content: center;
				flex-wrap: wrap;
				gap: 16px;
			}

			&-select {
				display: none;
			}
		}

		@media (--xl) {
			&-list {
				gap: 24px;
			}
		}
	}
</style>
